<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 17.59v-7l.45-.22a1 1 0 000-1.79l-9-4.46a1 1 0 00-.89 0l-9 4.54a1 1 0 000 1.79L5 11.66v4.63a1 1 0 00.25.66 9 9 0 0013.5.05 1 1 0 00.25-.67v-4.75l1-.5v6.51a1.5 1.5 0 101 0zM12.05 6.12l6.71 3.34L12 12.88 5.24 9.54zM17 15.94a7 7 0 01-10 0v-3.29l4.51 2.25a1.13 1.13 0 00.49.1 1 1 0 00.45-.11L17 12.58z"/><ellipse cx="12" cy="9.5" rx="1" ry=".75"/></svg>